import { render, staticRenderFns } from "./AdherenceIndex.vue?vue&type=template&id=64fe7af0&scoped=true&"
import script from "./AdherenceIndex.vue?vue&type=script&lang=js&"
export * from "./AdherenceIndex.vue?vue&type=script&lang=js&"
import style0 from "./AdherenceIndex.vue?vue&type=style&index=0&id=64fe7af0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fe7af0",
  null
  
)

export default component.exports